import React from "react";

export const Whitepaper = ({links, title}) => {

  return links?.length > 0 && (
    <React.Fragment>
      {title && (
        <p className="footer-menu-subtitle mb-3">{title}</p>
      )}
      <div className="d-flex flex-wrap">
        {
          links.map((item, index) => (
            <a className="btn btn-outline-white btn-outline-white--alt me-3 mb-3 d-inline-flex align-items-center zg-text-sm" target="_blank" rel="noreferrer" href={item?.file?.localFile?.publicURL || '#'} key={index}>
              {item.text}<svg className="ms-1" width="16" height="16"><use xlinkHref="#icon-download"/></svg>
            </a>
          ))
        }
      </div>
    </React.Fragment>
  )
}
